import { defaultIpgConfigByKey, type MerchantConfig } from '@pillar-portal/api-types';
import { ValorIpgSystemIdKey } from '@pillar-portal/api-types/ipg/valor/system-constants';
import { ValorIpgSystemId } from '@pillar-portal/api-types/ipg/valor/system-constants';
import type { CredentialFieldDefaults } from '../../credential-defaults';

export function resolveValorCredentialDefaults(
    merchantConfig: MerchantConfig | undefined
): CredentialFieldDefaults {
    const effectiveValorConfig =
        merchantConfig?.ipg[ValorIpgSystemIdKey] ?? defaultIpgConfigByKey[ValorIpgSystemIdKey];
    if (effectiveValorConfig.ipg_id !== ValorIpgSystemId) {
        throw new Error('Invalid Valor IPG configuration.');
    }
    return {
        domain: effectiveValorConfig.default_api_url,
        channel: effectiveValorConfig.default_channel,
    };
}
